export function loginAttempt(action) {
  return {
    type: action.type,
    data: {},
  }
}
